const SGTypes = {
    SG_ACTION_START:"SG_ACTION_START",
    SG_FETCH_DATA:"SG_FETCH_DATA",
    SG_FETCH_DATA_FAILED:"SG_FETCH_DATA_FAILED",
    SG_ADD_DATA:"SG_ADD_DATA",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
    adjResponse: [],
    project_id: "",
}

const SGReducer = (state=Initial_state, action) => {
    switch(action.type){
        case SGTypes.SG_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case SGTypes.SG_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload.response,
                project_id: action.payload.project_id,
                adjResponse: action.payload.data,
            }

        case SGTypes.SG_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }

        default:
            return state;
    }
};

export default SGReducer;